import axios from "axios";
import { useQuery } from "react-query";

import { config } from "../../utils/conf";
import { requestHeaders } from "../../utils/http";
import useSession from "../Auth/useSession";

export default function useGetCatalog() {
  const { accessToken } = useSession();

  return useQuery(
    "catalog-inventory",
    async () =>
      await axios.get(`${config.inventoryApiUrl}/v1/order-inventories`, {
        params: { outbound: true, itemClassId: "all" },
        headers: requestHeaders(accessToken),
      }),
    {
      refetchOnWindowFocus: false,
      placeholderData: { data: [] },
      staleTime: Infinity,
      enabled: !!accessToken,
      select: (data) => data?.data || [],
    },
  );
}
